import { ProductsPage } from '../productsPage';

// Get collection handle from the url parameter, e.g. ?collection=island-time
const urlParams = new URLSearchParams(window.location.search);
const collectionHandle = urlParams.get('collection') || "island-time";



window.addEventListener('DOMContentLoaded', async () => {
  const productsPage = new ProductsPage();
  productsPage.setupPageByCollection(collectionHandle);
});
